import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Dashboard2 from './components/Dashboard2';
import CustomLayout from './components/Layout';
import Login from './components/Login';
import AdminLogin from './components/AdminLogin';
import AdminPanel from './components/AdminPanel';

function RequireAdminAuth({ children }) {
  const isAuthenticated = Boolean(localStorage.getItem('adminToken'));
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <CustomLayout>
            <Dashboard />
          </CustomLayout>
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={
          <CustomLayout>
            <Dashboard />
          </CustomLayout>
        } />
        <Route path="/dashboard2" element={
          <CustomLayout>
            <Dashboard2 />
          </CustomLayout>
        } />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <RequireAdminAuth>
            <AdminPanel />
          </RequireAdminAuth>
        } />
      </Routes>
    </Router>
  );
}

export default App;
